import { IsNotEmpty, IsOptional, IsString } from 'class-validator';

export class UpdateUserAttributesDto {
  @IsString()
  @IsNotEmpty()
  name!: string;
}
